import { useCallback, useEffect } from 'react';
import { SCREENS } from '~constants';
import { useNavigation } from '@react-navigation/native';
import { useGetUserAccount } from '~hooks/user/useGetUser';
import { Alert, Platform } from 'react-native';
import dynamicLinks, { FirebaseDynamicLinksTypes } from '@react-native-firebase/dynamic-links';
import { useUserStore } from '~providers/userStore/zustand';
import { NavigationProps } from '~types/navigation/navigation.type';

const useDeepLinking = () => {
  const navigation = useNavigation<NavigationProps>();
  const user = useUserStore(state => state.user);
  const { refetch } = useGetUserAccount(user?.uid!);
  const openEvent = useCallback(
    async (eventID: string) => {
      const data = await refetch();
      if (data?.data) {
        navigation.navigate(SCREENS.HOME_STACK, { eventId: Number(eventID) });
        return;
      }
      Alert.alert('No permission to event');
    },
    [navigation, refetch],
  );
  const handleDynamicLink = useCallback(
    async (link: FirebaseDynamicLinksTypes.DynamicLink) => {
      const parts = link.url.split('/');
      const eventID = parts[parts.length - 1];
      openEvent(eventID);
    },
    [openEvent],
  );
  useEffect(() => {
    // Skip deep linking setup on web platform
    if (Platform.OS === 'web') {
      return;
    }

    const unsubscribe = dynamicLinks().onLink(handleDynamicLink);
    return () => unsubscribe();
  }, [handleDynamicLink]);

  const androidDeepLinking = useCallback(async () => {
    const initialLink = await dynamicLinks().getInitialLink();
    if (!initialLink) {
      return;
    }

    handleDynamicLink(initialLink);
  }, [handleDynamicLink]);
  useEffect(() => {
    // Skip deep linking setup on web platform
    if (Platform.OS === 'web') {
      return;
    }

    // if (!isAndroid) {
    //   return;
    // }

    androidDeepLinking();
  }, [androidDeepLinking]);
};

export default useDeepLinking;
